<template>
  <v-card tile flat>
    <div class="heading text-center">The Quality Mark</div>
    <!-- <div class="sub-heading text-center">
      this quality mark indicates the food is..
    </div> -->
    <v-row class="pa-10">
      <v-col cols="12" sm="4">
        <div class="d-flex justify-center  align-start">
          <img class="rounded img" src="../assets/images/good_food.jpg" />
        </div>
        <div class="sub-heading text-center  align-start">Good Food</div>
        <div class="body px-5 ">
          Food that is produced in a way that is beneficial for the environment,
          contribute to the local economy, protects the diversity of both plants
          and animals and avoid damaging and wasting natural resources.
        </div>
      </v-col>

      <v-col cols="12" sm="4">
        <div class="d-flex justify-center  align-start">
          <img class="rounded img" src="../assets/images/responsibly.jpeg" />
        </div>
        <div class="sub-heading text-center">Responsibly Produced</div>
        <div class="body px-5 ">
          Food that is produced on a farm that follow good agricultural
          practices.
        </div>
      </v-col>

      <v-col class="d-flex flex-column" cols="12" sm="4">
        <div class="d-flex justify-center align-start">
          <img class="rounded img" src="../assets/images/chemically_safe.jpg" />
        </div>
        <div class="sub-heading text-center">Chemically Safe</div>
        <div class="body px-5 ">
          Food that is monitored for levels of agricultural and chemical
          residues and comply with the safe limits present in foods.
        </div>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {};
</script>

<style scoped>
.img {
  display: block;
  width: 70%;
}
</style>
